module.exports = __webpack_public_path__ + "static/media/ph.2ee695e2.svg";